import { injectable } from 'inversify';
import { ModalManagerPlugin } from '@/plugins/modal-manager/modal-manager';

interface IModalManagerService {
    getModalManager(): ModalManagerPlugin;
}

@injectable()
class ModalManagerService implements IModalManagerService {
    private modalManager: ModalManagerPlugin;

    constructor() {
        this.modalManager = new ModalManagerPlugin();
    }

    public getModalManager(): ModalManagerPlugin {
        return this.modalManager;
    }
}

export { IModalManagerService, ModalManagerService };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/modal-manager/modal-manager-service.ts